import CustomizedButton from "@components/ButtonConfirm/ButtonConfirm";
import { PERMISSIONS } from "constants/permissions/permissions";
import React from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import {
  useCreateRoleMutation,
  useUpdateRoleMutation,
} from "store/role/role.api";
import "./CreateRoleComponent.scss";

const CreateRoleComponent = ({ onClose, role }) => {
  const { t } = useTranslation();
  const currentUser = useSelector((state) => state.auth.user);
  const companyId = currentUser?.companyId?._id;
  const allPermissions = currentUser?.roleId?.permissions;

  const [createRole, { isLoading: isCreating }] = useCreateRoleMutation();
  const [updateRole, { isLoading: isUpdating }] = useUpdateRoleMutation();

  const { register, handleSubmit } = useForm({
    defaultValues: role
      ? {
          name: role.name,
          permissions: role.permissions || [],
        }
      : {
          name: "",
          permissions: [],
        },
  });

  const onSubmit = async (data) => {
    try {
      const roleData = {
        ...data,
        companyId,
      };
      await createRole(roleData).unwrap();
      toast.success(t("role.create_form.create_success"));
      onClose();
    } catch {
      toast.error(t("role.create_form.create_error"));
    }
  };

  const onUpdate = async (data) => {
    try {
      const roleData = {
        ...data,
        companyId,
      };
      await updateRole({ id: role._id, data: roleData });
      toast.success(t("role.create_form.update_success"));
      onClose();
    } catch {
      toast.error(t("role.create_form.update_error"));
    }
  };

  return (
    <>
      <div className="row-container1 flex-column">
        {/* Nom du rôle */}
        <div className="input-container">
          <div className="input-title">{t("role.create_form.name")}</div>
          <input
            {...register("name", { required: "Le nom est requis" })}
            className="input-content1"
            placeholder={t("role.create_form.name_placeholder")}
          />
        </div>

        {/* Permissions */}
        <div className="input-container">
          <div className="input-title">{t("role.create_form.permission")}</div>
          <div className="permissions-container">
            {Object.entries(PERMISSIONS).map(([category, perms]) => (
              <div key={category} className="permission-category mt-2">
                <h4 className="category-title">{t(`role.${category}`)}</h4>
                <div className="permissions-container">
                  {perms
                    .filter((perm) => allPermissions?.includes(perm.code)) // filtre avec droits du user
                    .map((perm) => (
                      <label key={perm.code} className="permission-item">
                        <input
                          type="checkbox"
                          value={perm.code}
                          {...register("permissions")}
                          defaultChecked={role?.permissions?.includes(
                            perm.code
                          )}
                        />
                        {t(perm.label)}
                      </label>
                    ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Bouton */}
      <CustomizedButton
        creatingText={t(
          role ? "role.create_form.updating" : "role.create_form.creating"
        )}
        finalizeText={t(
          role ? "role.create_form.update" : "role.create_form.submit"
        )}
        handleCreate={() => {
          if (role) handleSubmit(onUpdate)();
          else handleSubmit(onSubmit)();
        }}
        isCreating={isCreating || isUpdating}
        className={"btn w-100"}
      />
    </>
  );
};

export default CreateRoleComponent;
